import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import style from '@styles/form/PasswordField.module.scss'
import { HidePasswordIcon } from '@components/icons/HidePasswordIcon'
import { ShowPasswordIcon } from '@components/icons/ShowPasswordIcon'
import { TextField } from '@components/form/TextField'

interface Props {
  errorMessages: Record<string, string>
  labelText: string
  placeholder: string
  inputId?: string
}

const PasswordField = React.forwardRef(
  (
    { errorMessages, inputId = 'password', labelText, placeholder }: Props,
    ref: React.Ref<HTMLInputElement>
  ) => {
    const [inputType, setInputType] = useState<string>('password')
    const { errors } = useFormContext()
    const { t } = useTranslation()

    return (
      <>
        <TextField
          label={labelText}
          inputId={inputId}
          type={inputType}
          placeholder={placeholder}
          error={errors[inputId]}
          errorMessages={errorMessages}
          ref={ref}
          containerStyles={{ height: '80px' }}
        />
        <div className={style.iconContainer}>
          {inputType === 'password' ? (
            <button
              className={style.iconButton}
              type="button"
              onClick={() => setInputType('text')}
              aria-label={t('form.showPassword')}
            >
              <ShowPasswordIcon />
            </button>
          ) : (
            <button
              className={style.iconButton}
              type="button"
              onClick={() => setInputType('password')}
              aria-label={t('form.hidePassword')}
            >
              <HidePasswordIcon />
            </button>
          )}
        </div>
      </>
    )
  }
)

export { PasswordField }
